export default "__VITE_ASSET__zO$VnVc3__"